// extracted by mini-css-extract-plugin
export default {"title":"styles_title__9MZKm","dateAndNumber":"styles_dateAndNumber__cAyFn","description":"styles_description__cBSMf","subTitle":"styles_subTitle__T4Vvx"};